import { render, staticRenderFns } from "./car-form.vue?vue&type=template&id=1c985c49&scoped=true&"
import script from "./car-form.vue?vue&type=script&lang=js&"
export * from "./car-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c985c49",
  null
  
)

export default component.exports